<template lang="">
  <a-modal
    :title="title"
    :width="500"
    v-model="visible"
    :destroyOnClose="true"
    :maskClosable="false"
    :confirmLoading="confirmLoading"
    @cancel="onCancel"
    @ok="onSubmit"
    :zIndex="9999"
  >
    <a-tabs v-model="activeKey">
      <a-tab-pane key="1" tab="二维码授权">
        <a-spin :spinning="spinning">
          <div class="form-item">
            <label><small>*</small>授权人：</label>
            <a-select
              style="width: 100%"
              v-model="authPersonId"
              @change="handleChange"
            >
              <a-select-option
                v-for="item in authPersons"
                :value="item.id"
                :key="item.id"
              >
                {{ item.UserName }}
              </a-select-option>
            </a-select>
          </div>
          <div class="qr-box">
            <template v-if="imgurl">
              <span v-if="isExpire" @click="reflesh" class="layer">
                <a-icon type="reload" />
                二维码失效 点击重试
              </span>
              <img :src="imgurl" alt="扫码授权" />
              <small>请让授权人使用微信扫码授权</small>
            </template>
          </div>
        </a-spin>
      </a-tab-pane>
      <a-tab-pane key="2" tab="管理员密码授权" force-render>
        <div class="form-item">
          <!-- <label><small>*</small>授权密码：</label> -->
          <a-input type="password" v-model="password"></a-input>
        </div>
      </a-tab-pane>
    </a-tabs>
    <template slot="footer">
      <template v-if="activeKey == 2">
        <a-button @click="onCancel">取消</a-button>
        <a-button type="primary" @click="onSubmit" :loading="confirmLoading"
          >确定</a-button
        >
      </template>
      <div />
    </template>
  </a-modal>
</template>

<script>
import md5 from "js-md5";
import { getUid } from "@/utils/common";
export default {
  name: "authLogin",
  props: {
    token: {
      type: String,
      default: ""
    },
    companyCode: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      default: "授权登录"
    },
    submit: Function,
    cancel: Function
  },
  data() {
    return {
      visible: false,
      confirmLoading: false,
      imgurl: "",
      isExpire: false,
      authPersons: [],
      activeKey: "1",
      authPersonId: "",
      spinning: false,
      authPerson: {},
      password: "",
      adminPassword: ""
    };
  },
  mounted() {
    this.getAuthPersons();
  },
  methods: {
    /**
     * @description: 获取授权人
     * @return {*}
     */
    getAuthPersons() {
      let that = this;
      that.$post("GetLoginAdmin", { notToken: true }).then(res => {
        let data = res.Data;
        if (data.Password) {
          that.adminPassword = data.Password;
          that.authPersons = data.LoginAdmins.filter(el => {
            el.id = getUid();
            if (el.OpenId) {
              return true;
            }
            return false;
          });
          this.visible = true;
        } else {
          this.onSubmitAfter();
        }
        console.log(that.authPersons);
      });
    },
    /**
     * @description: 切换授权人
     * @param {*} value
     * @return {*}
     */
    handleChange(value) {
      this.authPerson = this.authPersons.find(el => el.id == value);
      if (this.authPerson.OpenId) {
        this.getQrCode(this.authPerson.OpenId);
      }
    },
    /**
     * @description: 刷新二维码
     * @return {*}
     */
    reflesh() {
      this.isExpire = false;
      this.getQrCode(this.authPerson.OpenId);
    },
    /**
     * @description: 获取二维码
     * @param {*} openId
     * @return {*}
     */
    getQrCode(openId) {
      let that = this;
      if (!that.isExpire) {
        that.spinning = true;
        that
          .$post("LoginAdmin_GetQRCode", {
            openId,
            companyCode: this.companyCode,
            notToken: true
          })
          .then(response => {
            that.imgurl = "data:image/jpeg;base64," + response.Data.QRCode;
            that.spinning = false;
            that
              .$post(
                "LoginAdmin_LongPolingLogin",
                {
                  id: response.Data.KeyId,
                  notToken: true
                },
                { timeout: 3 * 60000 }
              )
              .then(() => {
                that.$emit("submit");
                // that.onAddAudit();
                that.visible = false;
              })
              .catch(() => {
                that.isExpire = true;
                that.spinning = false;
              });
          })
          .catch(() => {
            that.isExpire = true;
            that.spinning = false;
          });
        // userWxAuthApi
        //   .getQRCode({
        //     url:
        //       versionConfig.PMS_H5_PATH +
        //       versionConfig.AUTH_LOGIN_PATH +
        //       "?openId=" +
        //       openId
        //   })
        //   .then(response => {
        //     that.imgurl = "data:image/jpeg;base64," + response.data.qrCode;
        //     that.spinning = false;
        //     userWxAuthApi
        //       .longPolingGetToken(
        //         {
        //           id: response.data.keyId
        //         },
        //         { timeout: 5 * 60000, handleError: false }
        //       )
        //       .then(() => {
        //         this.$emit("submit");
        //         this.onAddAudit(1);
        //         this.visible = false;
        //       })
        //       .catch(() => {
        //         that.isExpire = true;
        //         that.spinning = false;
        //       });
        //   })
        //   .catch(() => {
        //     that.isExpire = true;
        //     that.spinning = false;
        //   });
      }
    },
    /**
     * @description: 提交
     * @return {*}
     */
    onSubmit() {
      if (this.confirmLoading) return;
      let { password } = this;
      if (!password) {
        this.$message.error("请输入密码");
        return false;
      }
      this.confirmLoading = true;
      password = md5(password, 32);
      if (this.adminPassword == password) {
        this.onSubmitAfter();
      } else {
        this.$message.error("密码错误");
      }
      this.confirmLoading = false;
      // const values = await this.$refs.dataForm.validateFields();
      // values.authPassWord = values.authPassWord
      //   ? md5(values.authPassWord)
      //   : null;
      // userWxAuthApi
      //   .AuthAdmin(values, {
      //     headers: {
      //       Authorization: this.token
      //     }
      //   })
      //   .then(() => {
      //     this.confirmLoading = false;
      //     this.onAddAudit(2);
      //     // this.$message.success("操作成功");
      //     this.$emit("submit");
      //     this.visible = false;
      //   })
      //   .catch(() => {
      //     this.confirmLoading = false;
      //   });
    },
    onSubmitAfter() {
      this.onAddAudit();
      this.$emit("submit");
      this.visible = false;
    },
    /**
     * @description: 授权记录
     * @param {*} type
     * @return {*}
     */
    onAddAudit(/*type*/) {
      // let msg = "";
      // if (this.title == "授权登录") {
      //   msg = `【${moment().format(
      //     "YYYY/MM/DD HH:mm:ss"
      //   )}】授权【超级系统管理员】登录【民宿】系统；方式：`;
      // } else {
      //   msg = `【${moment().format(
      //     "YYYY/MM/DD HH:mm:ss"
      //   )}】授权【超级系统管理员】在【民宿】系统修改密码；方式：`;
      // }
      // if (type == 2) {
      //   msg += "【管理员密码授权】";
      // } else {
      //   msg += `二维码授权；授权人：【${this.authPerson.Name}】`;
      // }
      this.$post(
        "AddLoginAdminLog",
        {
          urlQuery: `?CompanyCode=${this.companyCode}`
        },
        {
          headers: {
            Authorization: this.token
          }
        }
      );
      // userWxAuthApi.AddAudit(
      //   {
      //     tableName: "管理员",
      //     actionName: this.title,
      //     detail: msg
      //   },
      //   {
      //     headers: {
      //       Authorization: this.token
      //     }
      //   }
      // );
    },
    onCancel() {
      this.visible = false;
      this.$emit("cancel");
    }
  }
};
</script>
<style lang="less" scoped>
.form-item {
  display: flex;
  align-items: center;
  margin: 5px 0;
  label {
    min-width: 80px;
    text-align: right;
    small {
      color: #f00;
    }
  }
}
.qr-box {
  text-align: center;
  padding: 40px 0 15px;
  position: relative;
  height: 320px;
  img {
    width: 225px;
  }
  span {
    display: block;
    margin: 10px;
  }
  small {
    display: block;
    margin: 10px;
    color: #1890ff;
  }
  .anticon-reload {
    font-size: 40px;
    display: block;
    margin: 60px 0;
  }
  .layer {
    position: absolute;
    left: 50%;
    top: 40px;
    width: 225px;
    height: 225px;
    background: rgba(0, 0, 0, 0.75);
    color: #fff;
    font-size: 14px;
    padding-top: 20px;
    transform: translateX(-50%);
    margin: 0;
    z-index: 11;
  }
}
</style>
